import { useExplore } from '@/stores/explore';
import { Button, ModalV2 } from '@skand/ui';

export interface ShapeTypeInfoModalProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ShapeTypeInfoModal = ({ open, onCancel, onSubmit }: ShapeTypeInfoModalProps) => {
  const prevShapeType = useExplore(state => state.annotationOriginalCache?.annotation3d?.shapeType);
  const currentShapeType = useExplore(state => state.annotationDraft?.annotation3d?.shapeType);

  const getShapeType = () => {
    if (!currentShapeType) return '';
    return currentShapeType.charAt(0).toUpperCase() + currentShapeType.slice(1).toLowerCase();
  };

  return (
    <ModalV2 open={open}>
      <div className="mt-1 flex flex-col gap-6">
        <p className="color-neutral-800 typo-text-m">Change shape to {getShapeType()}?</p>
        <p className="color-neutral-800 typo-text-s">
          You’re about to change this annotation’s shape from a {prevShapeType?.toLocaleLowerCase()}{' '}
          to a {currentShapeType?.toLocaleLowerCase()}. This action can’t be undone, and any
          associated measurements will be removed.
        </p>
      </div>
      <div className="mt-4 w-full flex gap-2">
        <Button className="w-full cursor-pointer" onClick={onCancel} size="s">
          Cancel
        </Button>
        <Button className="w-full cursor-pointer" filled onClick={onSubmit} primary size="s">
          Confirm Changes
        </Button>
      </div>
    </ModalV2>
  );
};
